import { useNavigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

import ContactModal from 'modules/billing/components/ContactModalPage'

const ContactSalesModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(navigation.upgradePlan.fullPath())
  }

  return <ContactModal onClose={onClose} />
}

export default ContactSalesModalPage
